import { supabase } from '../supabase';

export const playlistTrackReviewsService = {
  // Crear o actualizar una calificación/comentario
  async createOrUpdateReview(playlistTrackId, userId, rating, comment) {
    const { data, error } = await supabase
      .from('playlist_track_reviews')
      .upsert({
        playlist_track_id: playlistTrackId,
        user_id: userId,
        rating: rating,
        comment: comment || null,
        updated_at: new Date().toISOString()
      }, {
        onConflict: 'playlist_track_id,user_id'
      })
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  // Obtener el review del usuario para una canción específica
  async getUserReview(playlistTrackId, userId) {
    const { data, error } = await supabase
      .from('playlist_track_reviews')
      .select('*')
      .eq('playlist_track_id', playlistTrackId)
      .eq('user_id', userId)
      .single();

    if (error && error.code !== 'PGRST116') throw error;
    return data;
  },

  // Obtener todos los reviews de una canción en la playlist
  async getTrackReviews(playlistTrackId) {
    const { data, error } = await supabase
      .from('playlist_track_reviews')
      .select('*')
      .eq('playlist_track_id', playlistTrackId)
      .order('created_at', { ascending: false });

    if (error) throw error;
    return data;
  },

  // Obtener promedio de calificaciones de una canción
  async getAverageRating(playlistTrackId) {
    const { data, error } = await supabase
      .from('playlist_track_reviews')
      .select('rating')
      .eq('playlist_track_id', playlistTrackId);

    if (error) throw error;

    if (!data || data.length === 0) {
      return { average: 0, total: 0 };
    }

    const total = data.length;
    const sum = data.reduce((acc, review) => acc + review.rating, 0);
    const average = sum / total;

    return { average, total };
  },

  // Obtener todos los reviews con información del usuario
  async getAllReviewsWithUsers(playlistTrackId) {
    // Primero obtener las reviews
    const { data: reviews, error: reviewsError } = await supabase
      .from('playlist_track_reviews')
      .select('*')
      .eq('playlist_track_id', playlistTrackId)
      .order('created_at', { ascending: false });

    if (reviewsError) {
      throw reviewsError;
    }

    // Luego obtener información de cada usuario
    if (reviews && reviews.length > 0) {
      const reviewsWithProfiles = await Promise.all(
        reviews.map(async (review) => {
          const { data: profile } = await supabase
            .from('profiles')
            .select('id, email, username, avatar_url')
            .eq('id', review.user_id)
            .single();

          return {
            ...review,
            profiles: profile || null
          };
        })
      );

      return reviewsWithProfiles;
    }

    return [];
  },

  // Eliminar un review
  async deleteReview(playlistTrackId, userId) {
    const { error } = await supabase
      .from('playlist_track_reviews')
      .delete()
      .eq('playlist_track_id', playlistTrackId)
      .eq('user_id', userId);

    if (error) throw error;
    return true;
  }
};
